import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from "react-redux";
import Layout from '../Layout';
import PageLoading from "../componentes/PageLoading";

const RequiereLogin = ({component: Component, noLayout, ...props}) => {
    const sesion = useSelector(state => state.sesion);

    switch (sesion.isLoggedIn) {
        case true:
            return noLayout 
                ? <Component sesion={sesion} {...props}/>
                : <Layout sesion={sesion}><Component sesion={sesion} {...props}/></Layout>;
        case null:
            return <PageLoading/>
        case false:
            return <Redirect
                to={{
                    pathname: "/login",
                    state: {from: props.location.pathname}
                }}
            />;
        default:
    }

}

const RouterConLogin = ({component, noLayout, ...props}) => <Route {...props} render={routeProps => <RequiereLogin
    component={component} noLayout={noLayout} {...routeProps} {...props.additional} />}/>


export default RouterConLogin;
